import styles from './Spinner.module.css';

interface SpinnerProps {
  id?: string;
}

export default function Spinner({ id = 'loading-spinner' }: SpinnerProps) {
  return (
    <div id={id} data-testid={id} aria-valuetext="loading" className={styles.loaderContainer}>
      <div className={styles.loader}></div>
    </div>
  );
}
